import type { Translation } from '../translations.types';

const translations: Translation = {
  logout: 'Cerrar sesión',
  openMenu: 'Abrir menú',
  closeMenu: 'Cerrar menú',
  author: 'Publicado por',
  'add-review': '¡Mmm! ¡Comparte tu historia gastronómica!',
  'add-review-to-food': 'Cuéntanos sobre tu experiencia con {{food}}',
  comments: {
    title: 'Comentarios',
    subtitle: 'Únete a la conversación',
    writeComment: 'Escribe un comentario...',
    placeholder: 'Escribe un comentario...',
    submit: 'Publicar',
    delete: 'Eliminar',
    noComments: '¡Aún no hay comentarios. Sé el primero en comentar!',
    loginToComment: 'Inicia sesión para dejar un comentario',
    loadMore: 'Cargar más',
    commentAdded: 'Comentario añadido con éxito',
    commentError: 'No se pudo añadir el comentario',
    commentDeleted: 'Comentario eliminado',
    deleteError: 'Error al eliminar el comentario',
    post: 'Publicar'
  },
  mentions: {
    noUsersFound: 'No se encontraron usuarios',
    searchingUsers: 'Buscando usuarios...',
  },
  food: {
    title: 'Comida',
    gourmets: 'Fans de {{food}}',
    bestPlaces: 'Mejores lugares para {{food}}',
    gourmetsSectionDescription:
      '¡Descubre quién conoce bien su {{food}}! Nuestros gourmets están clasificados por cuántas veces lo han probado y qué pensaron.',
    bestPlacesSectionDescription:
      '¿Buscando {{food}} increíble? ¡Estos lugares están calificados por personas que saben de lo que hablan!',
    beTheFirstReviewer: {
      title: '¡Sé el primero en reseñar {{foodName}}!',
      description: '¡Tu experiencia gastronómica importa! Comparte tu reseña y ayuda a otros amantes de la comida a descubrir este plato.',
      button: 'Escribir la primera reseña'
    }
  },
  drink: 'Bebida',
  place: 'Lugar',
  'where-did-you-eat': '¿Dónde comiste esto?',
  'what-did-you-eat': '¿Qué probaste?',
  localeCurrency: 'Moneda local',
  category: 'Categoría',
  name: 'Nombre',
  rating: 'Tu puntuación',
  welcome_modal: {
    title: '¡Bienvenido a BiteCritic!',
    subtitle: 'Descubre tu próximo plato favorito',
    description:
      'BiteCritic es una comunidad de amantes de la comida que comparten sus experiencias y califican la comida que han probado.',
    features: {
      title: 'Con BiteCritic, puedes:',
      rate: 'Calificar platos basándote en el sabor, no solo restaurantes',
      discover: 'Descubrir nuevas comidas basadas en reseñas auténticas',
      connect: 'Conectar con otros entusiastas de la comida',
      track: 'Seguir las comidas que quieres probar',
    },
    not_now: 'Ahora no',
    join_now: 'Únete ahora',
  },
  review: {
    label: 'Tu Opinión',
    writingIn: 'Estoy escribiendo esta reseña en',
    success: '¡Tu historia está publicada!',
    error: '¡Ups! Algo salió mal al compartir tu historia',
    foodReviewTitle:
      'Reseña de {{foodName}} por {{username}} en {{placeName}}, {{city}}',
    drinkReviewTitle:
      'Reseña de {{drinkName}} por {{username}} en {{placeName}}, {{city}}',
  },
  previous: 'Atrás',
  next: 'Siguiente',
  'submit-review': 'Comparte tu historia',
  cancel: 'Cancelar',
  type: 'Qué tipo',
  'select-food': 'Elige tu plato',
  cost: '¿Cuánto costó?',
  'rating-explanation': '¡Puntúalo! (1 = meh, 10 = ¡alucinante!)',
  'write-your-review': 'Cuéntanos todo...',
  'visited-at': '¿Cuándo fuiste?',
  reviews: {
    noReviews: 'No se encontraron reseñas',
    readFull: 'Lee la historia completa',
    showTranslation: 'Mostrar traducción',
    showOriginal: 'Mostrar original',
    translatedFrom: 'Traducido del {{language}}',
    filters: {
      title: 'Filtros',
      apply: 'Aplicar filtros',
      rating: 'Puntuación',
      cost: 'Precio',
      startDate: 'Desde',
      endDate: 'Hasta',
      location: 'Ubicación',
      radius: 'Radio de búsqueda (km)',
      sort: {
        label: 'Ordenar por',
        newest: 'Más recientes primero',
        oldest: 'Más antiguos primero',
        mostLiked: 'Mejor valorados',
        leastLiked: 'Peor valorados',
        mostExpensive: 'Más caros',
        cheapest: 'Más baratos',
      },
      sortOrder: {
        asc: 'ascendente',
        desc: 'descendente',
      },
      sortBy: {
        createdAt: 'Fecha',
        likeCount: 'Me gusta',
        cost: 'Precio',
      },
      active: {
        rating: 'Puntuación mínima: {{value}}',
        startDate: 'Desde: {{date}}',
        endDate: 'Hasta: {{date}}',
        cost: 'Precio mínimo: {{value}}',
        radius: 'Dentro de {{value}}km',
      },
    },
  },
  languages: {
    en: 'Inglés',
    nl: 'Holandés',
    tr: 'Turco',
    de: 'Alemán',
    fr: 'Francés',
    es: 'Español',
    it: 'Italiano',
    pt: 'Portugués',
    select: 'Seleccionar idioma',
  },
  validation: {
    'place-required': '¡Ups! Primero elige un lugar',
    'category-required': '¡Elige una categoría!',
    'review-min-length':
      'Un poco más de detalle sería genial (al menos 80 caracteres)',
    'rating-required': '¡No olvides puntuarlo!',
    'cost-positive': 'El precio debe ser mayor que cero',
    'visited-at-required': '¿Cuándo fuiste?',
    'type-required': '¿Comida o bebida?',
    'food-required': '¿Qué comiste?',
    'drink-required': '¿Qué bebiste?',
    'country-required': '¿De dónde eres?',
    required: 'Este campo es obligatorio',
  },
  auth: {
    welcomeBack: '¡Hola! 👋',
    loginToContinue: 'Vuelve a entrar',
    continueWithGoogle: 'Continuar con Google',
    continueWithApple: 'Continuar con Apple',
    logout: '¡Hasta luego!',
    login: 'Sign In',
    signup: 'Sign Up',
    signupToContinue: 'Join our foodie community',
    joinCommunity: '¡Únete a la fiesta gastronómica!',
    required: '¡Vamos a empezar!',
    actionRequiresAuth: '¡Ups! Se necesita un inicio de sesión rápido para eso',
    alreadyLoggedIn: '¡Ya has iniciado sesión!',
    goToProfile: 'Ir al Perfil',
    continueToFeed: 'Continuar al Feed',
    alreadyHaveAccount: '¿Ya tienes una cuenta?',
    benefits: {
      title: 'Mira lo que te estás perdiendo:',
      follow: 'Sigue tus comidas favoritas',
      review: 'Comparte tus aventuras gastronómicas',
      save: 'Guarda lugares para más tarde',
      community: 'Conoce a otros amantes de la comida',
      personalized: 'Recibe consejos de comida solo para ti',
    },
    cta: {
      login: '¡Vamos!',
      cancel: 'Quizás más tarde',
    },
    actions: {
      followFood: '¡Inicio de sesión rápido para seguir este delicioso plato!',
      unfollowFood: 'Inicia sesión para dejar de seguir',
    },
    joinNow: 'Join Now!',
  },
  profile: {
    follow: 'Seguir',
    unfollow: 'Dejar de seguir',
    followers: 'Seguidores',
    following: 'Siguiendo',
    avatar: 'Tu foto',
    change_avatar: 'Nueva foto',
    upload_avatar: 'Subir foto',
    title: 'Tu perfil',
    view: 'Ver perfil',
    username: 'Nombre de usuario',
    email: 'Correo electrónico',
    success: '¡Se ve bien!',
    error: 'Ups, algo salió mal',
    save: 'Guardar',
    firstName: 'Nombre',
    lastName: 'Apellido',
    birthDate: 'Fecha de nacimiento',
    country: 'País',
    bio: 'Sobre ti',
    bioPlaceholder: 'Cuéntanos sobre tus aventuras gastronómicas...',
    selectCountry: 'Selecciona tu país',
    deleteAccount: {
      button: 'Delete Account',
      title: 'Delete Your Account',
      warning:
        'Warning: This action cannot be undone. All your user data and preferences will be permanently deleted.',
      confirm: 'Delete My Account',
      error: 'Failed to delete account. Please try again later.',
    },
    noAccount: '¿No tienes una cuenta?',
  },
  onboarding: {
    welcome: '¡Bienvenido a BiteCritic!',
    setup_profile: 'Vamos a configurar tu perfil',
    username: 'Nombre de usuario',
    username_required: 'El nombre de usuario es obligatorio',
    username_min_length:
      'El nombre de usuario debe tener al menos 3 caracteres',
    username_pattern: 'Solo se permiten letras, números y guiones bajos',
    username_taken: 'Este nombre de usuario ya está en uso',
    username_available: '¡Nombre de usuario disponible!',
    username_requirements:
      'El nombre de usuario debe tener al menos 3 caracteres y solo puede contener letras, números y guiones bajos',
    checking_username: 'Comprobando disponibilidad del nombre de usuario...',
    first_name: 'Nombre',
    first_name_required: 'El nombre es obligatorio',
    first_name_min_length: 'El nombre debe tener al menos 2 caracteres',
    first_name_max_length: 'El nombre debe tener como máximo 20 caracteres',
    last_name: 'Apellido',
    last_name_required: 'El apellido es obligatorio',
    last_name_min_length: 'El apellido debe tener al menos 2 caracteres',
    last_name_max_length: 'El apellido debe tener como máximo 20 caracteres',
    birth_date: 'Fecha de nacimiento',
    birth_date_required: 'La fecha de nacimiento es obligatoria',
    country: 'País',
    complete_profile: 'Completar perfil',
    success: '¡Perfil actualizado con éxito!',
    error: 'Error al actualizar el perfil',
  },
  language: {
    select: 'Elige tu idioma',
    select_country: '¿Dónde estás?',
    select_language: '¿Qué idioma?',
    current: 'Idioma actual',
  },
  categories: {
    title: 'Categorías de comida',
    meta: {
      title: 'Categorías de comida - Descubre delicias culinarias',
      description:
        'Explora nuestras diversas categorías de comida y descubre delicias culinarias de todo el mundo. Encuentra reseñas, puntuaciones y dónde disfrutarlas.',
      categoryTitle: 'Categoría de comida',
      categoryDescription:
        'Explora {{category}} - Descubre {{count}} deliciosas comidas en esta categoría con reseñas y puntuaciones de amantes de la comida.',
      keywords:
        'categorías de comida, tipos de cocina, exploración culinaria, descubrimiento de comida',
      loading: 'Cargando categoría',
      defaultDescription:
        'Explora nuestras diversas categorías de comida y encuentra tu próxima aventura culinaria.',
    },
  },
  common: {
    noMoreReviews: 'No hay más reseñas',
    save: 'Guardar',
    error: {
      default: '¡Ups!',
      fetchFailed: 'Error al obtener datos',
      rateLimitExceeded:
        'Demasiadas solicitudes. Por favor, espera un momento antes de intentarlo de nuevo.',
    },
    search: 'Buscar',
    back: 'Volver',
    cancel: 'Cancelar',
    loading: 'Cargando...',
    delete: 'Eliminar',
    create: 'Crear',
    open: 'Abierto',
    closed: 'Cerrado',
    country: 'País',
    reviews: 'Reseñas',
    reviews_count: '{{count}} gourmets probaron esto',
    showMore: 'Mostrar más',
    showLess: 'Mostrar menos',
    uploadImage: 'Subir imagen',
    uploadMedia: 'Subir media',
    loadMore: 'Cargar más',
    backToHome: 'Volver al inicio',
    actions: {
      share: {
        label: 'Compartir',
        copied: 'Enlace copiado al portapapeles',
        copyFailed: 'Error al copiar enlace',
      },
    },
    exploreMore: 'Explorar Más',
    discoverExperiences: 'Descubre nuevas experiencias culinarias',
    reachedEndOfContent: 'Has llegado al final de este contenido',
    deleteMedia: 'Eliminar medios',
    uploadedMedia: 'Medios subidos',
    sort: 'Ordenar',
    comingSoon: 'Próximamente',
    next: 'Siguiente',
    notNow: 'Ahora no',
    close: 'Cerrar',
    saveChanges: 'Guardar cambios',
    food: 'Comida',
    previous: 'Anterior',
  },
  feed: {
    title: 'Tu Viaje Gastronómico Personal',
    description:
      'Sigue tus comidas, lugares y gourmets favoritos para crear tu feed de comida perfecto. Obtén recomendaciones personalizadas y nunca te pierdas una buena comida.',
    discover: 'Comenzar a Descubrir',
    personalizedTitle: 'Tu Feed de Comida',
    allReviewsTitle: 'Últimas Historias de Comida',
    personalizedDescription:
      'Mira reseñas de las comidas, lugares y gourmets que sigues.',
    joinCommunityDescription:
      'Únete a nuestra comunidad para obtener un feed personalizado basado en tus intereses.',
    noRelatedReviews:
      'Aún no tenemos reseñas que coincidan con tus intereses. ¡Veamos algunas historias globales!',
    showGlobalFeed: 'Mostrar Feed Global',
    myFeed: 'Mi Feed',
    globalFeed: 'Feed Global',
    globalDescription:
      'Descubre las últimas historias de comida de todo el mundo.',
    noGlobalReviews:
      '¡No hay reseñas globales disponibles en este momento. ¡Vuelve pronto!',
    meta: {
      title: 'Feed de Comida - Tu Viaje Gastronómico Personalizado',
      description:
        'Descubre las últimas reseñas e historias de comida de tus comidas, lugares y gourmets favoritos. Obtén recomendaciones personalizadas basadas en tus gustos.',
      keywords:
        'feed de comida, reseñas de comida, recomendaciones personalizadas, historias de comida, comunidad gastronómica',
    },
    followFoods: {
      title: 'Seguir Comidas',
      description:
        'Mantente al día con tus comidas favoritas y descubre nuevas variaciones.',
    },
    followPlaces: {
      title: 'Seguir Lugares',
      description:
        'Mantente actualizado con las últimas reseñas de tus lugares favoritos.',
    },
    followGourmets: {
      title: 'Seguir Gourmets',
      description:
        'Conéctate con amantes de la comida que comparten tus gustos y descubre sus recomendaciones.',
    },
  },
  statuses: {
    active: 'Activo',
    pending: 'Pendiente',
    rejected: 'Rechazado',
  },
  places: {
    radius: '¿Qué tan lejos?',
    noPlacesFound: 'No hay nada aquí todavía',
    tryAdjustingFilters: 'Intenta ajustar tus opciones de búsqueda',
    locationPermission: {
      title: '¿Dónde estás?',
      description:
        'Comparte tu ubicación para encontrar lugares deliciosos cerca',
      allow: 'Mostrar mi ubicación',
    },
    whereDidYouEat: '¿Dónde comiste esto?',
    searchByLocation: '¿A dónde quieres ir?',
    selectPlace: 'Escribe el nombre de un lugar',
    yourLocation: 'Estás aquí',
    searchOrUseLocation:
      'Busca un lugar específico o usa tu ubicación para descubrir lugares cercanos',
    locationStatus: {
      detecting: 'Detectando tu ubicación...',
      denied: 'Acceso a ubicación denegado',
      unavailable: 'Ubicación no disponible',
      found: '¡Ubicación encontrada!',
    },
    sort: {
      title: 'Ordenar por',
      ratingDesc: 'Calificación (Alta a Baja)',
      ratingAsc: 'Calificación (Baja a Alta)',
      distanceAsc: 'Más Cercanos',
      distanceDesc: 'Más Lejanos',
      nameAsc: 'Nombre (A-Z)',
      nameDesc: 'Nombre (Z-A)',
      reviewCountDesc: 'Más Reseñados',
      reviewCountAsc: 'Menos Reseñados',
      newestFirst: 'Más Recientes',
      oldestFirst: 'Más Antiguos',
    },
    period: {
      title: 'Período',
      ALL_TIME: 'Todo el Tiempo',
      LAST_WEEK: 'Última Semana',
      LAST_MONTH: 'Último Mes',
      LAST_YEAR: 'Último Año',
    },
    meta: {
      title: 'Descubre restaurantes cerca de ti',
      description: 'Encuentra y explora los mejores restaurantes de tu zona. Lee reseñas, ve fotos y descubre nuevas experiencias gastronómicas.',
      titleWithPlace: 'Mejores lugares cerca de {{place}}',
      descriptionWithPlace: 'Descubre los mejores restaurantes y lugares de comida cerca de {{place}} en un radio de {{radius}} km. Lee reseñas, consulta valoraciones y encuentra tu próximo lugar favorito para comer.'
    },
    navigation: {
      title: 'Lugares',
    },
    detail: {
      error: '¡Ups! No pudimos encontrar este lugar. ¿Intentas de nuevo?',
      sections: {
        popularFoods: {
          title: 'Lo más amado en {{place}}',
          description:
            'Estos platos son los más apreciados por nuestra comunidad gourmet en {{place}}. Clasificados por calificaciones y número de reseñas.',
          titleWithCity: 'Lo más amado en {{place}} en {{city}}',
          descriptionWithCity:
            'Estos platos son los más apreciados por nuestra comunidad gourmet en {{place}} en {{city}}. Clasificados por calificaciones y número de reseñas.',
        },
        gourmets: {
          title: 'Principales Gourmets en {{place}}',
          description:
            'Conoce a los amantes de la comida que mejor conocen {{place}}. Están clasificados por su número de reseñas y calificaciones.',
          titleWithCity: 'Principales Gourmets en {{place}} en {{city}}',
          descriptionWithCity:
            'Conoce a los amantes de la comida que mejor conocen {{place}} en {{city}}. Están clasificados por su número de reseñas y calificaciones.',
        },
        reviews: {
          title: 'Reseñas en {{place}}',
          titleWithCity: 'Reseñas en {{place}} en {{city}}',
        },
      },
    },
    emptyState: {
      title: 'No se encontraron lugares',
      description: '{{username}} aún no ha reseñado ningún lugar.'
    },
    userMapTitle: 'Mapa gastronómico de {{username}}',
    reviewsDrawer: {
      title: 'Reseñas para {{placeName}}',
      noReviews: 'Aún no hay reseñas para este lugar.',
      viewMore: 'Ver todas las reseñas',
      addReview: 'Añadir reseña'
    },
    viewAllVisited: 'Todos los lugares que {{username}} ha visitado y valorado'
  },
  settings: {
    title: 'Tu Configuración',
  },
  home: '// TODO: Check home type - Expected string, found object',
  'review-not-found': 'No se puede encontrar esta reseña',
  'go-back': 'Volver',
  actions: {
    share: 'Compartir con Amigos',
  },
  users: {
    title: 'Entusiastas de la Comida',
    searchPlaceholder: 'Buscar por nombre...',
    noResults: 'No se encontraron entusiastas de la comida',
    seoTitle: 'Críticos de Comida y Reseñadores',
    seoDescription:
      'Descubre críticos de comida y reseñadores en tu área. Conéctate con amantes de la comida que comparten tus pasiones culinarias y descubre nuevas experiencias gastronómicas.',
    seoKeywords: 'críticos de comida, reseñadores de comida, expertos culinarios, foodis, gourmets',
    navigation: {
      title: 'Foodies',
    },
    stats: {
      followers: 'Seguidores',
      following: 'Siguiendo',
      rating: 'Calificación',
      reviews: 'Reseñas',
    },
    map: {
      viewMap: 'Ver Mapa Gastronómico',
      seoTitle: 'Mapa gastronómico de {{username}}',
      seoDescription: 'Explora los lugares que {{username}} ha visitado y valorado en su mapa gastronómico.'
    },
    detail: {
      sections: {
        visitedPlaces: {
          title: 'Lugares Recientemente Visitados por {{username}}',
          description: 'Lugares donde {{username}} ha compartido experiencias culinarias',
        },
        likedFoods: {
          title: 'Comidas Favoritas de {{username}}',
          description: 'Comidas que {{username}} ha probado y reseñado',
        },
      },
    },
  },
  foods: {
    title: 'Comidas',
    meta: {
      title: 'Descubre Comidas Cerca de Ti',
      description:
        'Explora y descubre deliciosas comidas en tu área. Navega por reseñas, calificaciones y fotos de varios platos de restaurantes locales.',
    },
    searchPlaceholder: 'Buscar comidas...',
    noResults: 'No se encontraron comidas',
    sort: {
      nameAsc: 'Nombre A-Z',
      nameDesc: 'Nombre Z-A',
      ratingDesc: 'Mejor Valorados',
      ratingAsc: 'Peor Valorados',
      reviewCountDesc: 'Más Reseñas',
      reviewCountAsc: 'Menos Reseñas',
    },
    period: {
      allTime: 'Todo el Tiempo',
      lastWeek: 'Última Semana',
      lastMonth: 'Último Mes',
      lastYear: 'Último Año',
    },
  },
  navigation: {
    home: 'Inicio',
    discover: 'Descubrir',
    popular: 'Popular',
    community: 'Comunidad',
    placesNearMe: 'Lugares Cerca de Mí',
    foodsNearMe: 'Comidas Cerca de Mí',
    popularFoodsMonth: 'Comidas Populares del Mes',
    popularPlacesMonth: 'Lugares Mejor Valorados del Mes',
    mostReviewedPlacesMonth: 'Lugares Más Reseñados del Mes',
    myFeed: 'Mi Feed',
    myProfile: 'Mi Perfil',
    popularGourmetsMonth: 'Gourmets Populares del Mes',
    support: 'Soporte',
    contact: 'Contacto',
    gourmets: 'Encontrar Gourmets',
    privacy: 'Política de Privacidad',
    terms: 'Términos y Condiciones',
  },
  error: {
    pageNotFound: 'Página No Encontrada',
    pageNotFoundDescription:
      'La página que estás buscando puede haber sido eliminada, ha cambiado de nombre o no está disponible temporalmente.',
    needHelp: '¿Necesitas Ayuda?',
    contactUs:
      'Contacta a nuestro equipo de soporte y te ayudaremos a encontrar lo que buscas.',
  },
  contact: {
    title: 'Contáctanos',
    name: 'Tu Nombre',
    email: 'Dirección de Correo Electrónico',
    message: 'Mensaje',
    send: 'Enviar Mensaje',
    nameRequired: 'Por favor, introduce tu nombre',
    emailRequired: 'Por favor, introduce tu correo electrónico',
    emailInvalid: 'Por favor, introduce un correo electrónico válido',
    messageRequired: 'Por favor, introduce tu mensaje',
    pageTitle: 'Ponte en Contacto',
    pageDescription:
      '¿Tienes preguntas o necesitas ayuda? ¡Estamos aquí para ayudarte! Completa el formulario a continuación o envíanos un correo electrónico directamente.',
  },
  seo: {
    keywords: {
      food: 'comida',
      cuisine: 'cocina',
      reviews: 'reseñas',
      rating: 'puntuación',
      restaurants: 'restaurantes',
      dining: 'gastronomía',
    },
    food: {
      title: 'Reseña de {{foodName}}',
      description:
        'Descubre los mejores lugares para comer {{foodName}}. Lee reseñas honestas y encuentra dónde disfrutar de la más deliciosa {{foodName}} cerca de ti en BiteCritic.',
      defaultDescription:
        'Descubre {{foodName}} - reseñas, puntuaciones y dónde encontrar la mejor {{foodName}} cerca de ti.',
    },
    place: {
      defaultDescription:
        'Explora {{placeName}} - reseñas, calificaciones y platos populares en este lugar.',
      cityDescription:
        'Explora {{placeName}} en {{cityName}} - reseñas, calificaciones y platos populares en este lugar.',
    },
    review: {
      defaultDescription:
        '{{username}} evaluó {{foodName}} en {{placeName}}. Calificación: {{rating}}/{{maxRating}}',
      foodTitle: 'Reseña de {{foodName}} en {{placeName}} - {{rating}}/10',
      placeTitle: 'Reseña de {{placeName}} - {{rating}}/10',
      metaDescription:
        'Lee la reseña detallada de {{username}} sobre {{foodName}} en {{placeName}}. Calificación: {{rating}}/10. Descubre qué hace especial a este {{type}}.',
      authorTitle: 'Reseña de {{username}} sobre {{foodName}} en {{placeName}}',
      ratingScale: 'Escala de calificación: 0-10',
      reviewedType: {
        food: 'Plato',
        restaurant: 'Restaurante',
        product: 'Producto',
      },
    },
    user: {
      defaultDescription:
        'Descubre el viaje gastronómico de {{username}} - reseñas, platos favoritos y aventuras culinarias.',
    },
    category: {
      defaultDescription:
        'Explora comidas de {{categoryName}} - descubre los mejores platos, reseñas y dónde encontrarlos cerca de ti.',
    },
    meta: {
      siteName: 'BiteCritic',
      defaultTitle:
        'BiteCritic - Descubre y Comparte Experiencias Gastronómicas',
      defaultDescription:
        'Únete a amantes de la comida de todo el mundo para descubrir y compartir increíbles experiencias culinarias. Encuentra reseñas auténticas, calificaciones y fotos de platos cerca de ti.',
      defaultKeywords:
        'comida, restaurantes, reseñas, gastronomía, cocina, críticos gastronómicos',
    },
  },
  app: {
    actions: 'Acciones de la aplicación',
  },
  download: {
    ios_app: 'Descargar aplicación iOS',
    android_app: 'Descargar aplicación Android',
  },
  notifications: {
    title: 'Notificaciones',
    pageTitle: 'Notificaciones',
    pageDescription: 'Ver y gestionar tus notificaciones',
    markAllAsRead: 'Marcar todo como leído'
  },
  endOfScroll: {
    placesNearMe: 'Lugares Cercanos',
    placesNearMeSubtitle:
      'Encuentra restaurantes y establecimientos cerca de ti',
    globalFeed: 'Feed Global',
    globalFeedSubtitle: 'Ve lo que otros están disfrutando',
    findPeople: 'Encuentra Foodies',
    findPeopleSubtitle: 'Conéctate con otros amantes de la comida',
    foodsNearMe: 'Comidas Cercanas',
    foodsNearMeSubtitle: 'Descubre platos populares en tu zona',
  },
  'location': 'Ubicación',
  'review-modal-media-explanation': '¡Toma una foto o elige una de tu álbum para mostrar tu plato!',
  'review-modal-rating-explanation': '¿Cómo sabía? Da tu valoración honesta.',
  'review-modal-location-explanation': '¿Dónde disfrutaste este plato? ¡Compártelo con otros!',
  'draft-cleared': '¡Borrador eliminado con éxito!',
  'draft-save-error': '¡Ups! No se pudo guardar tu borrador',
  'clear-draft': 'Eliminar borrador',
  'media': 'Medios',
  'media.image': 'Imagen',
  'media.video': 'Vídeo',
  'add-food-review': 'Reseña de comida',
  errors: {
    invalidFileType: 'Tipo de archivo inválido. Por favor, sube solo imágenes JPG, PNG, WebP, HEIC o HEIF.',
    fileTooLarge: 'El archivo es demasiado grande. El tamaño máximo es {{size}}.',
    tooManyFiles: 'Demasiados archivos. El máximo permitido es {{max}}.'
  },
};

export default translations;
